// Produces a string JSON array of IANA time zone names compatible with Django

const TIMEZONES: string[] =
  typeof Intl !== "undefined" &&
  typeof (Intl as any).supportedValuesOf === "function"
    ? (Intl as any).supportedValuesOf("timeZone") // full IANA list from the platform
    : [
        // Fallback (minimal) if the browser doesn't support supportedValuesOf:
        "UTC",
        "America/New_York",
        "America/Chicago",
        "America/Denver",
        "America/Los_Angeles",
        "America/Phoenix",
        "America/Anchorage",
        "Pacific/Honolulu",
        "Europe/London",
        "Europe/Berlin",
        "Europe/Paris",
        "Asia/Tokyo",
        "Asia/Shanghai",
        "Asia/Kolkata",
        "Australia/Sydney",
      ];

export default TIMEZONES;
export const TIMEZONES_JSON: string = JSON.stringify(TIMEZONES);
